import React from 'react';
// import CharlieHRIntegrationContent from './components/CharlieHR/CharlieHRIntegrationContent';
import TabStructureComponent from 'components/tabs/TabStructureComponent';
import { useContext } from 'react';
import strings from '../../strings/strings.json';
import Notification, { NotificationType } from 'components/notifiers/Notification';
import { OrganisationDescriptionForm } from './components/OrganisationDescriptionForm';
import { useLocation } from 'react-router-dom';
import InformationIcon from 'assets/icons/other/InformationIcon';
import FileIcon from 'assets/icons/other/FileIcon';
import { MainSectionWithGaps } from 'components/sections/MainSection';
import { TabDefinition } from 'components/tabs/Tabs';
import OAFilesList from './files/OAFilesList';
import { OrganisationBill } from 'pages/admin/components/BillingList';
import {
    OrganisationOverviewContext,
    OrganisationOverviewProvider,
} from 'contextProviders/OrganisationOverviewContext';
import Header from 'components/sections/Header';

type State = {
    activeTabId: string;
};

export default function OrganisationOverviewPage(): JSX.Element {
    return (
        <OrganisationOverviewProvider>
            <OrganisationOverviewPageContent />
        </OrganisationOverviewProvider>
    );
}

function OrganisationOverviewPageContent(): JSX.Element {
    const { state } = useLocation();
    const { activeTabId } = (state as State) ?? {};

    const { organisation, errors } = useContext(OrganisationOverviewContext);

    const [savedDescription, setSavedDescription] = React.useState<boolean>(false);

    if (errors) {
        return (
            <>
                <Header title={strings.organisationOverviewPage.errors.pageHeader} />
                <MainSectionWithGaps>
                    <Notification
                        notificationType={NotificationType.DANGER}
                        title={strings.organisationOverviewPage.errors.errorTitle}
                        description={strings.organisationOverviewPage.errors.errorDescription}
                    />
                </MainSectionWithGaps>
            </>
        );
    }

    const tabDefinitions: TabDefinition[] = [
        {
            id: 'details',
            name: strings.organisationOverviewPage.tabs.details,
            icon: InformationIcon,
            content: (
                <OrganisationDescriptionForm
                    savedDescription={savedDescription}
                    setSavedDescription={setSavedDescription}
                />
            ),
        },
        {
            id: 'bills',
            name: strings.organisationOverviewPage.tabs.bills,
            icon: FileIcon,
            content: <OrganisationBill />,
        },
        {
            id: 'files',
            name: strings.organisationOverviewPage.tabs.files,
            icon: FileIcon,
            content: <OAFilesList />,
        },
        // {
        //     id: 'charlie-hr',
        //     name: strings.organisationOverviewPage.tabs.charlieHR,
        //     icon: FileIcon,
        //     content: <CharlieHRIntegrationContent />,
        // },
    ];

    return (
        <>
            <Header title={organisation!.name} />
            <MainSectionWithGaps>
                <TabStructureComponent initialActiveTabId={activeTabId} tabs={tabDefinitions} />
            </MainSectionWithGaps>
        </>
    );
}
